import React from 'react';
import { motion } from 'framer-motion';
import { FaUsers, FaHandshake, FaLightbulb, FaGlobe } from 'react-icons/fa';
import './About.css';

const About = () => {
  const values = [
    {
      icon: <FaUsers />,
      title: "Community First",
      description: "We believe in the power of community and work closely with local leaders to create sustainable change."
    },
    {
      icon: <FaHandshake />,
      title: "Transparency",
      description: "We maintain complete transparency in our operations and financial reporting to build trust with our donors."
    },
    {
      icon: <FaLightbulb />,
      title: "Innovation",
      description: "We continuously innovate our programs to better serve the evolving needs of children and communities."
    },
    {
      icon: <FaGlobe />,
      title: "Global Impact",
      description: "Our programs reach children across multiple countries, creating a global network of support and hope."
    }
  ];

  return (
    <section id="about" className="about-section">
      <div className="container">
        <motion.div 
          className="about-header"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2 className="section-title">About ATS Foundation</h2>
          <p className="section-subtitle">
            Founded in 2013, ATS Foundation has been dedicated to transforming the lives of underprivileged children 
            through education, healthcare, and community support programs.
          </p>
        </motion.div>

        <div className="about-content">
          <motion.div 
            className="mission-vision"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <div className="mission">
              <h3>Our Mission</h3>
              <p>
                To provide underprivileged children with access to quality education, healthcare, and essential resources 
                that enable them to break the cycle of poverty and reach their full potential.
              </p>
            </div>
            
            <div className="vision">
              <h3>Our Vision</h3>
              <p>
                A world where every child, regardless of their background, has the opportunity to learn, grow, and thrive 
                in a supportive and nurturing environment.
              </p>
            </div>
          </motion.div>

          <motion.div 
            className="values-section"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h3>Our Values</h3>
            <div className="values-grid">
              {values.map((value, index) => (
                <motion.div 
                  key={index}
                  className="value-item"
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                  viewport={{ once: true }}
                >
                  <div className="value-icon">
                    {value.icon}
                  </div>
                  <h4>{value.title}</h4>
                  <p>{value.description}</p>
                </motion.div>
              ))}
            </div>
          </motion.div>



          <motion.div 
            className="impact-stats"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h3>Our Impact</h3>
            <div className="stats-grid">
              <div className="stat-card">
                <h4>2,500+</h4>
                <p>Children Helped</p>
              </div>

              <div className="stat-card">
                <h4>25</h4>
                <p>Communities Served</p>
              </div>
              <div className="stat-card">
                <h4>10+</h4>
                <p>Years of Service</p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;